import { Cookie } from "@modules/util/Cookie.ts"

$(() => {
    const noticeFsk18ShownCookie = new Cookie(siteConfig.fsk18InfoStripeCookieName, {
        domain: SiteInfo.cookieDomain,
        path: "/",
    })

    $(document).on("click", "#fsk18-info .ladies-button-transparent", () => {
        noticeFsk18ShownCookie.expires = Cookie.getExpireDate(24 * 3600 * 365)
        noticeFsk18ShownCookie.value = siteConfig.fsk18InfoStripeCookieValue

        $("#fsk18-info").slideUp(300)

        if (SiteInfo.isMobileVersion) {
            const ihHeight = $(".vp > .head-menu").height()
            const viewportHeight = $(window).height() - ihHeight
            $(".header-index").css("min-height", viewportHeight)
        }
    })
})
